import React from 'react';
import PropTypes from 'prop-types';
import { Container, Content, Label } from './style';

function MobileItem({ className, content, label, weight = 'bold', months, type }) {
  return (
    <Container className={className}>
      {label ? (
        <Label weight={weight}>{label}</Label>
      ) : (
        <>
          <Content title={content} $weight='normal'>
            {content || '-'}
          </Content>
          {(months || type) && (
            <span>
              {months ? `${months}` : ''}
              {type ? `, ${type}` : ''}
            </span>
          )}
        </>
      )}
    </Container>
  );
}

MobileItem.propTypes = {
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  label: PropTypes.string,
  weight: PropTypes.oneOf(['bold', 'normal', 'light']),
  months: PropTypes.string,
  type: PropTypes.string
};

export default MobileItem;
